import { AddPhotoFile, SuggestionItem } from '../../interfaces';
import { FormFieldValue } from '../../types';

export const getSingleValueFromFormFieldValue = <T extends string | AddPhotoFile | SuggestionItem>(value: FormFieldValue): T => {
  const result: string | AddPhotoFile | SuggestionItem = Array.isArray(value) && value.length
    ? value[0] as T
    : value as T;

  return result as T;
};
